import React from 'react';

class Viewport extends React.Component {
  constructor(props) {
    super(props);

    // intersection observer to observe elements entering the viewport
    this.observer = null;

    // object tracking target elements by ID, added by child components
    this.targets = {};
  }

  componentDidMount() {
    this.observer = new window.IntersectionObserver(this.onObserve.bind(this), {
      root: null, // window
      rootMargin: '500px',
      threshold: 0.01
    });
  }

  componentWillUnmount() {
    this.observor = null;
  }

  // callback triggered by targets entering and exiting the viewport
  onObserve(entries, _observer) {
    for (let entry of entries) {
      for (let id in this.targets) {
        const { target, onEnter, onExit } = this.targets[id];
        if (target === entry.target) {
          if (entry.isIntersecting) {
            onEnter();
          } else {
            onExit();
          }
        }
      }
    }
  }

  // function provided to child components by viewport handle
  observe(targetId, target, onEnter, onExit) {
    this.targets[targetId] = { target, onEnter, onExit };
    this.observer.observe(target);
  }

  render() {
    // create a viewport handle and pass it to the child components
    const viewport = {
      ready: !!this.observer,
      observe: this.observe.bind(this),
      targets: this.targets
    }

    return (
      <div>
        {React.Children.map(this.props.children, child => {
          return React.cloneElement(child, { viewport });
        })}
      </div>
    );
  }
}

export default Viewport;
